// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposalSource } from './proposalSource.zod.ts';
import { ProposedMetric } from './proposedMetric.zod.ts';

export const ProposedCase = zod.object({
  "achievements": zod.string(),
  "anonymized_label": zod.string(),
  "approach": zod.string(),
  "client_name": zod.string(),
  "metrics": zod.array(ProposedMetric),
  "objective": zod.string(),
  "situation": zod.string(),
  "sources": zod.record(zod.string(), ProposalSource),
  "status": zod.enum(['live', 'pilot', 'pipeline', 'closed']),
  "type": zod.enum(['client', 'benchmark'])
});

export type ProposedCase = zod.input<typeof ProposedCase>;
export type ProposedCaseOutput = zod.output<typeof ProposedCase>;
